import * as React from "react";
import ValidatorsLayout from "../components/ValidatorsLayout";

const ReceptionPlacesValidators: React.FC = () => {
  return (
    <ValidatorsLayout />
  );
};

export default ReceptionPlacesValidators;